import { render, staticRenderFns } from "./emergencyPopup.vue?vue&type=template&id=5a56b1e6&scoped=true&"
import script from "./emergencyPopup.vue?vue&type=script&lang=js&"
export * from "./emergencyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56b1e6",
  null
  
)

export default component.exports